import { popoverLegacyDriverFactory } from '../Popover/Popover.driver';
import { Simulate } from 'react-dom/test-utils';

import type { TooltipSize } from './Tooltip.types';

export const tooltipLegacyDriverFactory = ({
  element,
  eventTrigger,
}: {
  element: Element | undefined;
  eventTrigger: typeof Simulate;
}) => {
  const popoverDriver = popoverLegacyDriverFactory({ element, eventTrigger });
  return {
    /** returns true if trigger element exists on the DOM */
    exists: async () => popoverDriver.exists(),
    /** returns true if tooltip element exists on the DOM */
    tooltipExists: async () => popoverDriver.isContentElementExists(),
    /** mouse over the target element */
    mouseEnter: async () => popoverDriver.mouseEnter(),
    /** mouse leaves the target element */
    mouseLeave: async () => popoverDriver.mouseLeave(),
    /** clicks outside the tooltip target */
    clickOutside: async () => popoverDriver.clickOutside(),
    /** returns tooltips content value in string */
    getTooltipText: () => {
      popoverDriver.mouseEnter();
      try {
        const text = popoverDriver.getContentElement()?.textContent;
        // Clean yourself!
        popoverDriver.mouseLeave();
        return text;
      } catch (e) {
        return null;
      }
    },
    /**
     * Checks whether tooltip has a given size
     * @param {boolean} sizeName The tooltip size
     * @return {Promise<boolean>}
     */
    hasSize: (sizeName: TooltipSize) =>
      element?.getAttribute('data-size') === sizeName,
  };
};
